<template>
    <Header
        elements="9"
        current="9"
    ></Header>
    <ThankYou></ThankYou>
</template>

<script>
import Header from '@/components/Header-Short-New.vue'
import ThankYou from '@/components/blocks/ThankYou.vue'
import http from "@/api/http";
import {to_top} from "@/helper";

export default {
    components: {
        Header,
        ThankYou
    },
    mounted() {
        to_top()
        this.init()
    },
    methods: {
        async init() {
            let { data } = await http.get('trademark-office-action/step-thank-you/' + this.$route.params.key);

            if (data.res) {
                if (data.data.data.status != 'C' || data.data.data.status_payment != 'Y') {
                    this.$router.push({ path: '/trademark-office-action/step-2/' + this.$route.params.key })
                }

                this.$store.commit('header/setTotal', data.data.data.total)
            }
        },
    }
}
</script>
